import React, {Fragment} from 'react';
import classes from './Card.css';
import Moment from 'react-moment';

const Card = ({countryStats={}}) => {
    //console.log('countryStats', countryStats);

  	return (
       <Fragment>
        <h1 className={classes.Country}>{countryStats.country}</h1>
        <article className={classes.Card}>
            <article className={classes.CardData} style={{border: '1px solid blue', boxShadow: 'inset 0 -5px rgb(27,0,255)'}}>
              <h3>Active Cases</h3>
              <p className={classes.Numbers}>{ Number(countryStats.cases).toLocaleString() }</p>
              <div className={classes.Date}><p className={classes.DateLabel}>Last Updated at:</p>
              <p><time> { new Date(countryStats.updated).toDateString()} </time></p></div>
              <p className={classes.Blurb}>Number of active cases of COVID-19</p>
            </article>
            <article className={classes.CardData} style={{border: '1px solid green', boxShadow: 'inset 0 -5px rgb(0,128,1)'}}>
              <h3>Recovered</h3>
              <p className={classes.Numbers}>{ Number(countryStats.recovered).toLocaleString() }</p>
              <div className={classes.Date}><p className={classes.DateLabel}>Last Updated at:</p>
              <p> <time> { new Date(countryStats.updated).toDateString()} </time></p></div>
              <p className={classes.Blurb}>Number of recoveries from COVID-19</p>
            </article>
            <article className={classes.CardData} style={{border: '1px solid red', boxShadow: 'inset 0 -5px rgb(255,2,0)'}}>
              <h3>Deaths</h3>
              <p className={classes.Numbers}>{ Number(countryStats.deaths).toLocaleString() }</p>
              <div className={classes.Date}><p className={classes.DateLabel}>Last Updated at:</p>
              <p><time> { new Date(countryStats.updated).toDateString()} </time></p></div>
              <p className={classes.Blurb}>Number of deaths by COVID-19</p>
            </article>
            <article className={classes.CardData} style={{border: '1px solid red', boxShadow: 'inset 0 -5px rgb(255,2,0)'}}>
              <h3>Critical Cases</h3>
              <p className={classes.Numbers}>{ Number(countryStats.critical).toLocaleString() }</p>
              <div className={classes.Date}><p className={classes.DateLabel}>Last Updated at:</p>
              <p><time> { new Date(countryStats.updated).toDateString()} </time></p></div>
              <p className={classes.Blurb}>Number of critical cases of COVID-19</p>
            </article>
        </article>
        </Fragment>
  	)
}

export default Card;


// WEBPACK FOOTER //
// ./src/components/Card/Card.js